import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useMediaQuery } from 'react-responsive'
import { t, Select } from '@lingui/macro'
import LocalisedImage from '../LocalisedImage'

import './ImageTextSection.scss'

// Enter
const TOGGLE_KEY_CODE = 13

export const Image = ({ imgSrc }) => (
  <div className="image-text-section__container__right">
    <LocalisedImage className="image-text-section__container__right__image image-text-section__container__right__image--rounded" src={imgSrc} alt={t`About Yoti`} />
  </div>
)

Image.propTypes = {
  imgSrc: PropTypes.string.isRequired,
}

export const ToggleContentButton = ({ isContentShown, onShowContentToggle, onKeyDown }) => (
  <div
    role="button"
    tabIndex={0}
    onClick={onShowContentToggle}
    onKeyDown={onKeyDown}
    className="image-text-section__container__toggle-btn"
  >
    <span><Select value={isContentShown} true="Hide" false="Show" other="" /></span>
  </div>
)

ToggleContentButton.propTypes = {
  isContentShown: PropTypes.bool.isRequired,
  onShowContentToggle: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired
}

const ImageTextSection = ({
  children, imgSrc, contentToggled, contentToggleEnabled
}) => {
  const [showContent, setShowContent] = useState(contentToggled);

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  const onShowContentToggle = () => {
    setShowContent(!showContent)
  }

  const onKeyDown = (event) => {
    if (event.keyCode === TOGGLE_KEY_CODE) {
      onShowContentToggle()
    }
  }

  useEffect(() => {
    setShowContent(contentToggled)
  }, [contentToggled])

  return (
    <div className="image-text-section__container">
      <div className="image-text-section__container__left">
        { React.Children.map(children, (child, index) => (showContent || index === 0 ? child : null))}
        { showContent && isMobile && imgSrc && <Image imgSrc={imgSrc} />}
        { contentToggleEnabled && (<ToggleContentButton isContentShown={showContent} onShowContentToggle={onShowContentToggle} onKeyDown={onKeyDown} />)}
      </div>
      { showContent && !isMobile && imgSrc && (<Image imgSrc={imgSrc} />)}
    </div>
  )
}

ImageTextSection.defaultProps = {
  imgSrc: null,
  contentToggled: false,
  contentToggleEnabled: false
}

ImageTextSection.propTypes = {
  imgSrc: PropTypes.string,
  children: PropTypes.node.isRequired,
  contentToggled: PropTypes.bool,
  contentToggleEnabled: PropTypes.bool
}

export default ImageTextSection
